var React = require('react');

function Sedan (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M55.961 7.972C55.254 5.944 53.451 4 51.194 4H13.056C10.8 4 8.871 5.944 8.165 7.972L1 28.562v27.5C1 57.953 2.55 60 4.444 60h3.444C9.801 60 11 57.953 11 56.062V53h42v3.062C53 57.953 54.449 60 56.361 60h3.444C61.7 60 63 57.953 63 56.062v-27.5l-7.039-20.59zM12.994 42.02c-2.772 0-5.01-2.233-5.01-5s2.238-5 5.01-5 5.01 2.233 5.01 5-2.238 5-5.01 5zm38.262 0c-2.772 0-5.01-2.233-5.01-5s2.238-5 5.01-5 5.01 2.233 5.01 5-2.238 5-5.01 5zM32 25H7.889l5.167-15h38.138l5.167 15H32z"}));
}

Sedan.defaultProps = {"width":"64","height":"64","viewBox":"0 0 64 64"};

module.exports = Sedan;

Sedan.default = Sedan;
